<template lang="html">
  <v-snackbar
    :value='value'
    @input="$emit('close')"
    :top="true"
    :multi-line="true"
    :color="color">
    <slot name="main">
      {{ text }}
    </slot>
    <v-spacer />
    <v-btn
      flat
      @click="$emit(&quot;close&quot;)">
      <slot name="closeButtonText">
        <v-icon color="green">mdi-check</v-icon>
      </slot>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    value: Boolean,
    color: String,
    show: Boolean
  },
  data: () => {
    return {
      text: 'Snackbar without any info',
      visible: false
    }
  },
  watch: {
    show: function (val) {
      this.visible = !!this.show
    }
  }
}

</script>

<style lang="css" scoped>
</style>
